// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/Opengraph/MetatagsCards/Google.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/Opengraph/MetatagsCards/Google.tsx");
  import.meta.hot.lastModified = "1732036225890.1997";
}
// REMIX HMR END

import Heading from "~/components/Heading";
export function Google({
  title,
  description,
  url
}) {
  return <div id="google" className="pt-2">
      <div className="mobile-shadow-google max-[770px]:px-3 max-[770px]:py-3 rounded-md">
        <div className="card-google">
          <Heading tag="h2" className="!text-[#1a0dab] !leading-5 hover:underline cursor-pointer break-words">
            {title}
          </Heading>
        </div>
        <div className="card-google-url text-[#006621] flex items-center">
          <Heading tag="h2" className="mr-2"> {url} </Heading>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" className="w-2 h-3 fill-current">
              <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
            </svg>
          </span>
        </div>
        <span className="w-full h-[1px] bg-slate-200 block mt-1 mb-1 min-[770px]:hidden"></span>
        <span className="text-[#545454] text-[13px] google-description break-words" dangerouslySetInnerHTML={{
        __html: description
      }} />
      </div>
    </div>;
}
_c = Google;
var _c;
$RefreshReg$(_c, "Google");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;